import { reactive } from 'vue';
import { fmtThaiDate, fmtThaiDateTimeBE } from './thaiTime.js';
import { taxHistoryV2Api } from '../services/taxHistoryV2Api.js';

const state = reactive({
  forms: [],
  totalCount: 0,
  page: 1,
  pageSize: 50,
  totalPages: 0,
  loading: false,
  error: '',
  filters: {
    status: null,
    yearId: null,
    search: '',
    includePlayground: false,
    // #776 — UpdatedDate range as ICT days (YYYY-MM-DD). Today on a fresh load of the page; '' = no bound.
    // Set once when the module loads, so going to a form and back keeps whatever the admin picked or cleared.
    startDate: fmtThaiDate(new Date(), ''),
    endDate: fmtThaiDate(new Date(), ''),
  },
  detail: null,
  detailLoading: false,
  detailError: '',
  detailErrorStatus: null,
});

async function loadForms(filters = {}) {
  const { page, pageSize, ...nextFilters } = filters;
  state.filters = {
    ...state.filters,
    ...nextFilters,
  };
  state.loading = true;
  state.error = '';

  try {
    const result = await taxHistoryV2Api.list({
      ...state.filters,
      page: page ?? state.page,
      pageSize: pageSize ?? state.pageSize,
    });
    state.forms = result?.items || [];
    state.totalCount = result?.totalCount || 0;
    state.page = result?.page || result?.pageNumber || page || 1;
    state.pageSize = result?.pageSize || pageSize || state.pageSize;
    state.totalPages = result?.totalPages || 0;
    return result;
  } catch (error) {
    state.forms = [];
    state.totalCount = 0;
    state.totalPages = 0;
    state.error = error.message || 'Unable to load Tax History V2';
    throw error;
  } finally {
    state.loading = false;
  }
}

async function loadFormDetail(formId) {
  state.detailLoading = true;
  state.detailError = '';
  state.detailErrorStatus = null;
  state.detail = null;

  try {
    const result = await taxHistoryV2Api.getById(formId);
    state.detail = result;
    return result;
  } catch (error) {
    state.detailError = error.message || 'Unable to load Tax History V2 detail';
    state.detailErrorStatus = error.httpStatus ?? error.status ?? null;
    throw error;
  } finally {
    state.detailLoading = false;
  }
}

/**
 * #53-PRD — `08/10/2569 17:04` (วัน/เดือน/ปี พ.ศ. เวลา 24 ชม. เวลาไทย) ทุกภาษา · เดิมใช้ `toLocaleString`
 * ⇒ EN ขึ้น `10/08/2026, 05:04 PM` (เดือนนำ) · 🔴 `TaxHistoryV2ExportWriter.FormatDate` (ZIP/CSV ฝั่ง API)
 * ต้องเปลี่ยนตามกันเสมอ
 */
function formatDate(value) {
  return fmtThaiDateTimeBE(value, '—');
}

export { state, loadForms, loadFormDetail, formatDate };
